import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add\"><defs><style type=\"text/css\"></style></defs><path d=\"M972.8 460.8h-409.6v-409.6a51.2 51.2 0 0 0-102.4 0v409.6h-409.6a51.2 51.2 0 1 0 0 102.4h409.6v409.6a51.2 51.2 0 1 0 102.4 0v-409.6h409.6a51.2 51.2 0 1 0 0-102.4z\" p-id=\"2007\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol